module.exports = __webpack_public_path__ + "static/newsletter-oct-2019-a02020bdd13a0d208f5bf1c76fdeb44f.png";